import type { IntegrationEntry } from '@/lib/brand/integrations-catalog';

type Status = IntegrationEntry['status'];

export const statusOrder: Status[] = [
  'available',
  'beta',
  'rollout',
  'guided',
  'planned',
];

export const statusCopy: Record<
  Status,
  { label: string; meaning: string; tone: string }
> = {
  available: {
    label: 'Live',
    meaning: 'Connect it yourself today.',
    tone: 'bg-emerald-50 text-emerald-700 ring-emerald-600/15',
  },
  beta: {
    label: 'Beta',
    meaning: 'Open to everyone while we refine it.',
    tone: 'bg-sky-50 text-sky-700 ring-sky-600/15',
  },
  rollout: {
    label: 'Rolling out',
    meaning: 'Opening to more accounts in stages.',
    tone: 'bg-amber-50 text-amber-800 ring-amber-600/20',
  },
  guided: {
    label: 'Guided setup',
    meaning: 'We set it up with you.',
    tone: 'bg-violet-50 text-violet-700 ring-violet-600/15',
  },
  planned: {
    label: 'Planned',
    meaning: 'On the roadmap, not yet available.',
    tone: 'bg-gray-100 text-gray-600 ring-gray-500/15',
  },
};

export function byStatus(a: IntegrationEntry, b: IntegrationEntry) {
  return statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status);
}
